import { cloneDeep, defaultsDeep } from 'lodash'
import { DeepPartial } from '../../../models/util.model'
import { Replenishment } from '../models/replenishment.entity'

/**
 * The replenishment initial state
 */
const REPLENISHMENT_INITIAL_STATE: DeepPartial<Replenishment> = {
  status: 'PENDING',
  product: {},
  priority: 20,
}

/**
 * Initialize a partial replenishment
 * @param brand - the partial replenishment
 * @returns the replenishment updated
 */
export function initReplenishment(
  replenishment: Partial<Replenishment> = {},
): Replenishment {
  return defaultsDeep(cloneDeep(replenishment), REPLENISHMENT_INITIAL_STATE)
}
